import { render, staticRenderFns } from "./SAccProjectServices.vue?vue&type=template&id=31bbf679&scoped=true"
import script from "./SAccProjectServices.vue?vue&type=script&lang=ts"
export * from "./SAccProjectServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bbf679",
  null
  
)

export default component.exports